import React from 'react';
import 'src/style/tenant.css';
import { useDispatch } from 'react-redux';
import { createTenant } from 'src/redux/Actions/Tenant';
import { MdClose } from 'react-icons/md';

export default function CreateTenantForm({ onClose }) {
  const dispatch = useDispatch();
  const handleCreateTenantFormSubmit = (e) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const tenantData = {
      name: data.get('name'),
      start_date: data.get('start-date'),
      end_date: data.get('end-date'),
      domain: data.get('domain'),
      description: data.get('description'),
    };
    dispatch(createTenant(tenantData)).then(() => {
      window.location.reload();
    });
  };

  return (
    <form
      onSubmit={handleCreateTenantFormSubmit}
      className="div-flex-column right-form-layout div-space-between"
    >
      <div className="div-flex-column rg-20">
        <div className="div-flex-row div-space-between div-align-center">
          <span className="text-xxxl text-bold">Tenant Form</span>
          <MdClose size="18px" onClick={onClose} />
        </div>
        <div className="form-body-section div-flex-column rg-20">
          <div className="div-flex-column">
            <span className="text-md text-bold">Name:</span>
            <input
              name="name"
              className="form-input-section"
              size="small"
              type="text"
            />
          </div>
          <div className="div-flex-row cg-20">
            <div className="div-flex-column">
              <span className="text-md text-bold">Start Date:</span>
              <input
                name="start-date"
                className="form-input-section"
                type="date"
                id="date"
              />
            </div>
            <div className="div-flex-column">
              <span className="text-md text-bold">End Date:</span>
              <input
                name="end-date"
                className="form-input-section"
                type="date"
                id="date"
              />
            </div>
          </div>
          <div className="div-flex-column">
            <span className="text-md text-bold">Domain:</span>
            <input
              name="domain"
              className="form-input-section"
              size="small"
              type="text"
              placeholder="expoundtechnivo.com"
            />
          </div>
          <div className="div-flex-column">
            <span className="text-md text-bold">Description:</span>
            <input
              name="description"
              className="form-input-section"
              size="small"
              type="text"
            />
          </div>
        </div>
      </div>
      <div className="div-flex-end">
        <button className="btn-black" type="submit">
          Submit
        </button>
      </div>
    </form>
  );
}
